module.exports = __webpack_public_path__ + "static/section_5-2668cc7c23df352fd8c57cd4e69adcf8.png";